<template>
  <div class="customer-logs">
    <van-steps
      direction="vertical"
      :active="100"
    >
      <van-step
        v-for="(flow, index) in logsList"
        :key="index"
      >
        <div class="pd1-flow-item">
          <div class="pd1-flow-item-left">
            <h3>{{ flow.index  }}、{{ flow.log_content }}</h3>
          </div>
          <div class="pd1-flow-item-right">
            {{ flow.create_time }}
          </div>
        </div>
      </van-step>

    </van-steps>

  </div>
</template>

<script>
import menZhenService from "@/apis/menZhen/index.js";

export default {
  data() {
    return {
      neijingDetail: {},
      tijianDetail: {},
      logsList: [],
    };
  },
  created() {
    const { query } = this.$route;
    if (query.menzhen_work_id_neijing) {
      this.workDetail({
        work_id: query.menzhen_work_id_neijing,
        type: "neijing",
      });
    }
    if (query.menzhen_work_id_tijian) {
      this.workDetail({
        work_id: query.menzhen_work_id_tijian,
        type: "tijian",
      });
    }
  },
  filters: {
    customerStatus(status) {
      const evelMap = {
        1: "新客户",
        2: "历史客户",
      };
      return evelMap[status];
    },
    openStatus(status) {
      const openMap = {
        0: "未绑定",
        1: "已绑定",
      };
      return openMap[status];
    },
    surveyStatus(status) {
      const evelMap = {
        0: "未签字",
        1: "已签字",
      };
      return evelMap[status];
    },
    stateStatus(status) {
      const evelMap = {
        0: "未读",
        1: "已读",
      };
      return evelMap[status];
    },
    visitStatus(status) {
      const evelMap = {
        0: "未回访",
        1: "已回访",
      };
      return evelMap[status];
    },
    reportStatus(status) {
      const evelMap = {
        0: "未读",
        1: "已读",
      };
      return evelMap[status];
    },
    tjStatus(status) {
      const evelMap = {
        0: "否",
        1: "是",
      };
      return evelMap[status];
    },
    operationXuzhi(status) {
      const evelMap = {
        0: "未读",
        1: "已读",
      };
      return evelMap[status];
    },
    evalStatus(status) {
      const evelMap = {
        0: "待评估（未填写）",
        1: "待评估（已填写）",
        2: "评估通过",
        3: "评估不通过",
      };
      return evelMap[status];
    },
    myiStatus(status) {
      const evelMap = {
        0: "未填写",
        1: "已填写",
      };
      return evelMap[status];
    },
    bookStatus(status) {
      const evelMap = {
        0: "待预约",
        1: "已预约",
        2: "已完成",
        3: "已取消",
      };
      return evelMap[status];
    },
  },
  methods: {
    workDetail({ work_id }) {
      const params = {
        work_id,
      };
      menZhenService.workServiceLogList(params).then((res) => {
        res.forEach((item, index) => {
          item.index = res.length - index;
        });
        this.logsList = res;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.customer-status {
}
.customer-status-list {
  padding: 20px;
}
.customer-status-title {
  font-size: 18px;
  font-weight: 600;
}
.customer-status-item {
  display: flex;
  .customer-status-label {
    width: 150px;
  }
  .customer-status-content {
  }
}
</style>